import constants from "../constants";

const {
  UPDATE_MAIN_USER,
  INIT_CLIENT,
  INIT_MAIN_USER_SOCKET,
  REMOVE_MAIN_USER,
  UPLOAD_MAIN_USER_IMAGE,
  DELETE_MAIN_USER_IMAGE,
  UPLOAD_PROJECT_IMAGE,
  DELETE_PROJECT_IMAGE,
  OPEN_CLIENT_RESERVATION_SELECTOR,
  SELECT_CLIENT_RESERVATION,
  CLOSE_CLIENT_RESERVATION_SELECTOR,
  UPDATE_MAIN_USER_EMAIL,
} = constants;

export const updateMainUser = (data) => ({
  type: UPDATE_MAIN_USER,
  data,
});

export const removeMainUser = () => ({
  type: REMOVE_MAIN_USER,
});

export const initClient = (data) => ({
  type: INIT_CLIENT,
  data,
});

export const initMainUserSocket = (data) => ({
  type: INIT_MAIN_USER_SOCKET,
  data,
});

export const uploadMainUserImage = (data) => ({
  type: UPLOAD_MAIN_USER_IMAGE,
  data,
});

export const deleteMainUserImage = (data) => ({
  type: DELETE_MAIN_USER_IMAGE,
  data,
});

export const uploadProjectImage = (data) => ({
  type: UPLOAD_PROJECT_IMAGE,
  data,
});

export const deleteProjectImage = (data) => ({
  type: DELETE_PROJECT_IMAGE,
  data,
});

export const openClientReservationSelector = (data) => ({
  type: OPEN_CLIENT_RESERVATION_SELECTOR,
  data,
});

export const selectClientReservation = (data) => ({
  type: SELECT_CLIENT_RESERVATION,
  data,
});

export const closeClientReservationSelector = () => ({
  type: CLOSE_CLIENT_RESERVATION_SELECTOR,
});

export const updateMainUserEmail = (data) => ({
  type: UPDATE_MAIN_USER_EMAIL,
  data,
});
